export const ADMIN_ROUTES = [
  '/perfil',
  '/configuracoes',
  '/relatorios',
  '/relatorios-financeiros',
  '/colaborador',
  '/usuarios',
  '/eventos',
  '/formularios'
  // Nota: /eventos/detalhe/ não é uma rota administrativa
];
